export default __webpack_public_path__ + "static/media/Group 8548.e3fea3ea.png";